// extracted by mini-css-extract-plugin
export default {"wrapper":"cOUND__wrapper","tagsIconPlus":"Mayoa__tagsIconPlus","dropdown":"B7BB8__dropdown","tag":"MkQVa__tag","dropdownItem":"FyaHD__dropdownItem","pathItem":"ah50U__pathItem"};